import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  loginWithPassword,
  logout,
  resendForgotOtp,
  resendLoginOtp,
  resetPassword,
  sendForgotOtp,
  sendLoginOtp,
  verifyForgotOtp,
  verifyLoginOtp,
} from './api';
import type { AuthSuccess } from './types';

export const authKeys = { all: ['auth'] as const, me: () => [...authKeys.all, 'me'] as const };

export function useLoginPassword() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: loginWithPassword,
    onSuccess: (d: AuthSuccess) => qc.setQueryData(authKeys.me(), d.user),
  });
}
export function useSendLoginOtp() {
  return useMutation({ mutationFn: sendLoginOtp });
}
export function useResendLoginOtp() {
  return useMutation({ mutationFn: resendLoginOtp });
}
export function useVerifyLoginOtp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: verifyLoginOtp,
    onSuccess: (d: AuthSuccess) => qc.setQueryData(authKeys.me(), d.user),
  });
}
export function useSendForgotOtp() {
  return useMutation({ mutationFn: (phone: string) => sendForgotOtp(phone) });
}
export function useResendForgotOtp() {
  return useMutation({ mutationFn: (phone: string) => resendForgotOtp(phone) });
}
export function useVerifyForgotOtp() {
  return useMutation({ mutationFn: verifyForgotOtp });
}
export function useResetPassword() {
  return useMutation({ mutationFn: (newPassword: string) => resetPassword(newPassword) });
}
export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onSuccess: () => qc.removeQueries({ queryKey: authKeys.all }),
  });
}
